<template>
  <v-card>
    <!-- <v-toolbar dark color="secondary">
      <v-toolbar-title>Admin Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar> -->
    <v-toolbar flat dark color="cyan">
      <v-toolbar-items>
        <v-btn flat @click="currentSelection = 'profile'"><v-icon left>person</v-icon>Profile</v-btn>
        <v-btn v-if="user.permissions.others.manageUsers" flat @click="currentSelection = 'users'"><v-icon left>group</v-icon>Users</v-btn>
        <v-btn v-if="user.permissions.others.manageUsers" flat @click="currentSelection = 'roles'"><v-icon left>lock</v-icon>Roles and Permissions</v-btn>
        <v-btn v-if="user.permissions.others.manageVenders" flat @click="currentSelection = 'vendors'"><v-icon left>assignment_ind</v-icon>Vendors</v-btn>
        <v-btn v-if="user.permissions.others.manageBuilders" flat @click="currentSelection = 'builders'"><v-icon left>home</v-icon>Builders</v-btn>
        <v-btn v-if="user.permissions.others.manageTaskTemplates" flat @click="currentSelection = 'tasktemplates'"><v-icon left>list_alt</v-icon>Task List Templates</v-btn>
        <v-btn v-if="isAdmin" flat @click="currentSelection = 'otherSettings'"><v-icon left>settings</v-icon>Other Admin Settings</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- Main Admin Content Area -->
      <profile :editUser="profile" v-if="currentSelection === 'profile'" class="mt-3" :profile="true"/>
      <users v-if="currentSelection === 'users'" class="mt-3"/>
      <roles v-if="currentSelection === 'roles'" class="mt-3"/>
      <vendors v-if="currentSelection === 'vendors'" class="mt-3" @closeDialog="closeDialog"/>
      <builders v-if="currentSelection === 'builders'" class="mt-3" @closeDialog="closeDialog"/>
      <task-templates v-if="currentSelection === 'tasktemplates'" class="mt-3" :segment="taskTemplateSegment" @resetView="resetView"/>
      <other-settings v-if="currentSelection === 'otherSettings'" class="mt-3"/>
    <!-- End: Main Admin Content Area -->
  </v-card>
</template>

<script>
import CreateUser from './users/CreateUser'
import Users from './users/Users'
import Roles from './Roles'
import Vendors from '../vendors/VendorList'
import Builders from '../builders/BuilderList'
import TaskTemplates from '../tasks/TaskTemplates'
import OtherSettings from './OtherSettings'

export default {
  data () {
    return {
      taskTemplateSegment: 'Pre-Construction',
      currentSelection: 'profile',
      notifications: false,
      sound: true,
      widgets: false
    }
  },
  created () {
    console.log('User List', this.$store.getters.userList)
  },
  computed: {
    isAdmin () {
      return this.user.role === 'Admin'
    },
    profile () {
      return {...this.user, profile: true}
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    resetView (segment) {
      this.taskTemplateSegment = segment
      this.currentSelection = null
      setTimeout(() => {
        this.currentSelection = 'tasktemplates'
      }, 500)
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  },
  components: {
    Users,
    Roles,
    Vendors,
    Builders,
    TaskTemplates,
    OtherSettings,
    Profile: CreateUser
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue